import React from 'react'

import Header from '../../Header'
import { buttons } from '../../../helpers/const'
import Content from "./Content";

class MediaPlan extends React.Component {
  constructor(props) {
    super(props);
    console.log(this.props);
  }

  render() {
    const { currentUser, mediaPlan } = this.props;


    return (
      <React.Fragment>
        <div className="flex flex-center flex-justify-center mh-100vh" style={{ paddingTop: '80px' }}>
          <Header
            buttonText={buttons.plan.text}
            buttonUrl={buttons.plan.url}
            currentUser={currentUser}
            personaName={`${mediaPlan.country} - ${mediaPlan.budget}$ - ${mediaPlan.created_at}`}
          />

          <Content
            mediaPlan={mediaPlan}
          />
        </div>
      </React.Fragment>
    )
  }
}

export default MediaPlan
